import { render } from "./opportunities.vue?vue&type=template&id=6dec1056&scoped=true"
import script from "./opportunities.vue?vue&type=script&lang=js"
export * from "./opportunities.vue?vue&type=script&lang=js"

import "./opportunities.vue?vue&type=style&index=0&id=6dec1056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dec1056"]])

export default __exports__